import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React from "react";

const P1: React.FC = () => {
  const Notice1 = `
Este Proyecto de Acuerdo tiene como finalidad establecer un mecanismo excepcional que permita a las personas en específica situación de vulnerabilidad económica cumplir con su obligación tributaria del impuesto predial unificado, mediante el pago en especie con servicios de valor equivalente, definidos y regulados por la Administración Distrital.
La actual coyuntura socioeconómica ha incrementado el número de familias que enfrentan dificultades para asumir sus cargas fiscales. En particular, adultos mayores sin ingresos fijos, personas con discapacidad, víctimas del conflicto armado, hogares en pobreza extrema y pequeños propietarios que viven en sus predios sin mayores ingresos, constituyen una franja poblacional que requiere respuestas institucionales diferenciales y justas a través de medidas de acción afirmativa como la que se plantea en este proyecto.

Este mecanismo de pago en especie tiene un doble propósito: en primera medida garantizar el recaudo efectivo de tributos de difícil cobro, sin acudir a embargos ni desalojos que puedan conllevar la vulneración de derechos fundamentales de personas en estado de debilidad manifiesta, y por otra parte, reconocer otras formas de pago y aporte que pueden realizar estas personas al bienestar colectivo, como la prestación de servicios comunitarios, u otras actividades valorables por la administración.
  
  `;

  return (
    <section className={style.Noticia}>
      <div className={style.ContainerPDF}>
        <iframe
          title="Proposicion 043"
          src="https://drive.google.com/file/d/1TYSKJ5vV3almHRyngf38v7mYZTwCZTqJ/preview"
          className={style.PdfViewer}
          allow="autoplay"
        />
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          Proposicion 043: Predial de servicio social y comunitario{" "}
        </h1>
        <h5 className={style.Fecha}>Junio 03 del 2025</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde{" "}
        </p>
      </div>
    </section>
  );
};

export default P1;
